<template>
  <v-dialog hide-overlay v-model="show" width="80%">
    <v-card>
      <v-card-actions>
        <v-btn @click="submit">追加</v-btn>
        <v-btn @click="show = false" class="ml-2">{{
          $t('app.buttons.back')
        }}</v-btn>
      </v-card-actions>

      <v-card-text>
        <!-- <v-flex md6 sm6 xs12>
          <v-text-field label="権限CD"/>
        </v-flex>-->
        <v-data-table
          :headers="headers"
          :items="roles"
          :rows-per-page-items="[10]"
          class="elevation-0"
          hide-actions
          item-key="roleId"
          select-all
          v-model="selected"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-checkbox
                hide-details
                primary
                v-model="props.selected"
              ></v-checkbox>
            </td>
            <td :key="head.text" v-for="head in headers">
              {{ props.item[head.value] }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        { text: '権限グループCD', value: 'roleCode', sortable: false },
        { text: '権限グループ名', value: 'roleName', sortable: false },
      ],
      roles: [],
      query: {
        page_index: 1,
        page_size: 1000,
      },
      selected: [],
      show: false,
    }
  },
  methods: {
    loadRoles() {
      return this.$http.get(`/auth-service/auth/get-role-list`).then((res) => {
        if (res.data.success) {
          return res.data.data.data
        } else {
          return []
        }
      })
    },
    load() {
      this.loadRoles().then((r) => {
        this.roles = r
      })
    },
    submit() {
      this.$emit('submit', this.selected)
      this.show = false
    },
    popup() {
      this.show = true
    },
  },
  watch: {
    show(value) {
      if (value && this.roles.length <= 0) {
        this.load()
      }
    },
  },
}
</script>
